export const FETCH_ALL_BUSINESS = 'fetch_all_business';
export const FETCH_ALL_BUSINESS_SUCCESS = 'fetch_all_business_success';
export const EDIT_BUSINESS = 'edit_business';
export const DELETE_BUSINESS = 'delete_business';
export const CREATE_BUSINESS = 'create_business';
export const CREATE_BUSINESS_SUCCESS = 'create_business_success';
export const UPDATE_BUSINESS_SUCCESS = 'update_business_success';
export const UPDATE_BUSINESS = 'update_business';
export const DELETE_BUSINESS_SUCCESS = 'delete_business_success';
export const SET_BUSINESS = 'set_business';
export const SET_ROLE = 'set_role';
export const GET_BUSINESS = 'get_business';
export const GET_BUSINESS_SUCCESS = 'get_business_success';